import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  // 设置属性
  state: {
    selected:"1",//组件选择标记 默认设置最新. 1: 最新 ;2: 最热; 3: 动态
    infoTypeName:"全部", //默认显示全部列表信息
    roleType:"1",//游客角色 默认不显示发帖
    isAdminType:"1",//1 ：教职工和学生 2：管理员
  },
  // 获取属性的状态
  getters: {
    //获取选择状态
    selected: state => state.selected,
    infoTypeName: state => state.infoTypeName,
    roleType: state => state.roleType,
    isAdminType: state => state.isAdminType
  },

  // 设置属性状态
  mutations: {
    setSelected(state, selected) {
      state.selected = selected
    },
    setInfoTypeName(state, infoTypeName) {
      state.infoTypeName = infoTypeName
    },
    setRoleType(state, infoTypeName) {
      state.roleType = infoTypeName
    },
    setIsAdminType(state, isAdminType) {
      state.isAdminType = isAdminType
    },
  },

  // 应用mutations
  actions: {
    setSelected({ commit }, selected) {
      commit('setSelected', selected)
    },
    setInfoTypeName({ commit }, infoTypeName) {
      commit('setInfoTypeName', infoTypeName)
    },

    setRoleType({ commit }, selected) {
      commit('setRoleType', selected)
    },
    setIsAdminType({ commit }, selected) {
      commit('setIsAdminType', selected)
    },
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js